<template>
  <div v-if="data" class="rec">
    <div class="d-flex align-items-start justify-content-between flex-wrap" style="gap: 10px;">
      <div>
        <h2 class="h6 font-weight-bold mb-1"><i class="fe fe-star mr-1"></i>Recommended for your facility</h2>
        <div class="small">
          From your {{ data.submission.form_title }} assessment ({{ (data.submission.created_at || "").slice(0, 10) }}):
          {{ data.gaps.length }} missing item{{ data.gaps.length === 1 ? "" : "s" }} on offer, about {{ money(data.totals.best_offers_total) }} in all.
          <router-link :to="`/assessments/submissions/${data.submission.id}`">See the assessment</router-link>
        </div>
      </div>
      <button type="button" class="btn btn-sm rec-btn" @click="addAll"><i class="fe fe-shopping-cart mr-1"></i>Add all to cart</button>
    </div>
    <div class="rec-list mt-3">
      <router-link v-for="g in data.gaps" :key="g.form_item_id" :to="`/marketplace/products/${g.offers[0].vendor_product_id}`" class="rec-card">
        <div class="rec-need">Need {{ g.shortfall_qty }} · {{ g.procurement_item.name }}</div>
        <div class="font-weight-bold rec-name">{{ g.offers[0].name }}</div>
        <div class="small text-muted">{{ g.offers[0].vendor ? g.offers[0].vendor.name : "" }}</div>
        <div class="mt-1"><strong>{{ money(g.offers[0].unit_price) }}</strong> <span class="small text-muted">× {{ g.offers[0].quantity }}</span></div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { money, stored, addOfferToCart } from "./assessments";

// Marketplace strip for facility users: offers for the gaps of their latest assessment (GET marketplace/recommended).
export default {
  name: "RecommendedOffers",
  data() {
    return { data: null };
  },
  created() {
    const user = stored("user");
    const jwt = localStorage.getItem("jwt");
    if (!jwt || jwt === "null" || !user || !["provider", "provider_employee"].includes(user.type)) return;
    this.axios
      .get("/api/v1/auth/marketplace/recommended")
      .then((res) => (this.data = res.data.data && res.data.data.gaps.length ? res.data.data : null))
      .catch(() => (this.data = null));
  },
  methods: {
    money,
    addAll() {
      this.data.gaps.forEach((g) => addOfferToCart(g.offers[0]));
      this.$toasted.success(`${this.data.gaps.length} item(s) added to your cart`, { position: "top-center", duration: 3000 });
    },
  },
};
</script>

<style scoped>
.rec { background: #f0fdfa; border: 1px solid #99f6e4; border-radius: 12px; padding: 16px 18px; margin-bottom: 20px; color: #134e4a; }
.rec-btn { background: #0d9488; color: #fff; border-radius: 8px; font-weight: 600; }
.rec-btn:hover { color: #fff; opacity: .9; }
.rec-list { display: flex; gap: 10px; overflow-x: auto; padding-bottom: 4px; }
.rec-card { flex: 0 0 210px; background: #fff; border-radius: 10px; padding: 10px 12px; color: #1e293b; box-shadow: 0 1px 3px rgba(0,0,0,.06); }
.rec-card:hover { text-decoration: none; box-shadow: 0 0 0 2px #0d9488; color: #1e293b; }
.rec-need { font-size: .7rem; text-transform: uppercase; letter-spacing: .03em; color: #b91c1c; font-weight: 700; }
.rec-name { font-size: .88rem; }
</style>
